import { createFileRoute } from '@tanstack/react-router'
import { TaxRatesPage } from '@/features/quote-builder/tax/tax-rates-page'

export const Route = createFileRoute('/_authenticated/tax-rates')({
  staticData: { title: 'Tax Rates' },
  component: TaxRatesPage,
})
